import React from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, AlertTriangle, CheckCircle, XCircle, ArrowLeft, Download } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
export function ComplianceDetailPage() {
  const {
    id
  } = useParams();
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  return <DashboardLayout title="Compliance Tracking" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2474">
      <div className="mb-6" data-id="element-2475">
        <Link to="/authority/compliance" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-4" data-id="element-2476">
          <ArrowLeft className="w-4 h-4" data-id="element-2477" /> Back to Compliance
        </Link>
        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-2478">
          <div data-id="element-2479">
            <h1 className="text-2xl font-bold mb-1" data-id="element-2480">
              Sunrise Developers - Green Valley
            </h1>
            <p className="text-gray-500 font-mono text-sm" data-id="element-2481">
              Application ID: {id || 'CMP-8821'} • RERA Registration
            </p>
          </div>
          <div className="flex gap-3" data-id="element-2482">
            <button className="px-4 py-2 border border-red-300 bg-red-50 text-red-700 text-sm font-bold hover:bg-red-100 flex items-center gap-2" data-id="element-2483">
              <XCircle className="w-4 h-4" data-id="element-2484" /> Reject
            </button>
            <button className="px-4 py-2 bg-green-600 text-white text-sm font-bold hover:bg-green-700 flex items-center gap-2" data-id="element-2485">
              <CheckCircle className="w-4 h-4" data-id="element-2486" /> Approve Application
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2487">
        <div className="lg:col-span-2 space-y-8" data-id="element-2488">
          {/* Checklist */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-2489">
            <h2 className="font-bold text-lg mb-4" data-id="element-2490">Compliance Checklist</h2>
            <div className="space-y-4" data-id="element-2491">
              {[{
              item: 'Land Title Clearance',
              status: 'Verified',
              date: 'Oct 20, 2024'
            }, {
              item: 'Environmental Clearance',
              status: 'Verified',
              date: 'Oct 21, 2024'
            }, {
              item: 'Layout Plan Approval',
              status: 'Pending Review',
              date: '-'
            }, {
              item: 'Fire Safety NOC',
              status: 'Pending Review',
              date: '-'
            }].map((check, i) => <div key={i} className="flex items-center justify-between p-4 border border-gray-200 bg-gray-50" data-id="element-2492">
                  <span className="font-medium text-sm" data-id="element-2493">{check.item}</span>
                  <div className="flex items-center gap-3" data-id="element-2494">
                    <span className="text-xs text-gray-500" data-id="element-2495">{check.date}</span>
                    <span className={`px-2 py-1 text-xs font-bold rounded border ${check.status === 'Verified' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-2496">
                      {check.status.toUpperCase()}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Communication */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-2497">
            <h2 className="font-bold text-lg mb-4" data-id="element-2498">Communication History</h2>
            <div className="space-y-4" data-id="element-2499">
              <div className="border-l-2 border-blue-500 pl-4" data-id="element-2500">
                <p className="text-sm font-bold" data-id="element-2501">Authority Request</p>
                <p className="text-sm text-gray-600 mt-1" data-id="element-2502">
                  Please submit the updated fire safety plan as per 2024
                  guidelines.
                </p>
                <span className="text-xs text-gray-400 mt-2 block" data-id="element-2503">
                  Yesterday, 2:00 PM
                </span>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-2504">
                <p className="text-sm font-bold" data-id="element-2505">Developer Response</p>
                <p className="text-sm text-gray-600 mt-1" data-id="element-2506">
                  Attached the revised plan. Please review.
                </p>
                <span className="text-xs text-gray-400 mt-2 block" data-id="element-2507">
                  Today, 10:00 AM
                </span>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-2508">
              <textarea placeholder="Add a note or request..." className="w-full p-3 border border-gray-300 text-sm h-24 mb-2" data-id="element-2509"></textarea>
              <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2510">
                Send Message
              </button>
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-2511">
          <div className="bg-white border border-gray-300 p-6" data-id="element-2512">
            <h3 className="font-bold text-sm mb-4" data-id="element-2513">Submitted Documents</h3>
            <div className="space-y-2" data-id="element-2514">
              {['Title_Deed.pdf', 'Env_Clearance.pdf', 'Layout_Plan_v2.dwg'].map((doc, i) => <div key={i} className="flex items-center justify-between p-2 border border-gray-100 hover:bg-gray-50" data-id="element-2515">
                  <span className="text-xs font-mono truncate max-w-[150px]" data-id="element-2516">
                    {doc}
                  </span>
                  <button className="text-blue-600 hover:text-blue-800" data-id="element-2517">
                    <Download className="w-4 h-4" data-id="element-2518" />
                  </button>
                </div>)}
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 p-6" data-id="element-2519">
            <h3 className="font-bold text-sm text-yellow-900 mb-2 flex items-center gap-2" data-id="element-2520">
              <AlertTriangle className="w-4 h-4" data-id="element-2521" /> Violation Check
            </h3>
            <p className="text-xs text-yellow-800 mb-4" data-id="element-2522">
              This plot falls within 500m of a protected lake zone. Special
              clearance required.
            </p>
            <button className="w-full py-2 bg-yellow-100 text-yellow-900 border border-yellow-300 text-xs font-bold hover:bg-yellow-200" data-id="element-2523">
              View Zone Map
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}